// extracted by mini-css-extract-plugin
module.exports = {"crumbs":"Breadcrumbs_crumbs__1K9eM","crumb":"Breadcrumbs_crumb__1PEXs","underline":"Breadcrumbs_underline__2qzv5","underlineFill":"Breadcrumbs_underlineFill__1_2HV"};